import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class FavIconService {
  private document = inject(DOCUMENT);


  /**
   * Set favicon dynamically
   * @param faviconPath - Path to the favicon file (e.g., './assets/images/favicon.ico')
   */
  setFavicon(faviconPath: string): void {
    // Remove existing favicon links
    const head = this.document.getElementsByTagName('head')[0];
    const existingLinks = this.document.querySelectorAll('link[rel*="icon"]');

    existingLinks.forEach(link => {
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
    });

    // Create and add new favicon links
    this.addFaviconLink(head, 'icon', faviconPath);
    this.addFaviconLink(head, 'shortcut icon', faviconPath);
    this.addFaviconLink(head, 'apple-touch-icon', faviconPath);
  }

  /**
   * Add favicon link element to head
   */
  private addFaviconLink(head: HTMLHeadElement, rel: string, href: string): void {
    const link = this.document.createElement('link');
    link.setAttribute('rel', rel);
    link.setAttribute('type', 'image/x-icon');
    link.setAttribute('href', href);
    head.appendChild(link);
  }

  /**
   * Set page title
   * @param title - Page title
   */
  setTitle(title: string): void {
    this.document.title = title;
  }

  /**
   * Set both favicon and title
   * @param faviconPath - Path to the favicon file
   * @param title - Page title
   */
  setFaviconAndTitle(faviconPath: string, title: string): void {
    this.setFavicon(faviconPath);
    this.setTitle(title);
  }
}
